import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { API_BASE_URL, FILE_BASE_URL } from "../../../apiConfig";

function AccountingSection(props) {
    const [selectedPdf, setSelectedPdf] = useState(""); // State to track the selected PDF
    const [accountingStatements, setAccountingStatements] = useState([]); // State to store API data
    const iframeRef = useRef(null); // Reference to the iframe for scrolling

    const styles = {
        tabContent: {
            padding: '0 6rem',
            display: 'block', // Ensure the tab content is visible
            paddingBottom: '2rem',
        },
        iframe: {
            width: '100%',
            height: '100vh',
            border: 'none',
        },
        responsivePadding: {
            padding: '0 1rem', // Reduced padding for smaller screens
        },
        card: {
            width: '200px',
            height: '120px', // Increased height for better spacing
            background: 'var(--blue)',
            color: 'white',
            display: 'flex',
            flexDirection: 'column', // Stack content vertically
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '8px',
            cursor: 'pointer',
            margin: '1rem',
            textAlign: 'center',
            boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
            transition: 'background-color 0.3s ease', // Smooth transition for background color
            padding: '1rem', // Added padding for better spacing
        },
        activeCard: {
            background: 'var(--yellow)', // Yellow background for active card
            color: 'black', // Change text color for better contrast
        },
        cardContainer: {
             display: 'flex',
    flexWrap: 'nowrap', // Prevent wrapping
    justifyContent: 'flex-start', // Align cards to the left
    gap: '1rem',
    marginBottom: '2rem',
    overflowX: 'auto', // Enable horizontal scrolling
    whiteSpace: 'nowrap', // Prevent text wrapping
    paddingLeft: '1rem',

        },
        mobileCard: {
            width: '100%', // Full width for mobile
            height: '100px', // Adjust height for mobile
        },
        yearText: {
            fontWeight: 'bold', // Make the year bold
            fontSize: '18px', // Slightly larger font size for the year
        },
        statementText: {
            marginTop: '0.5rem', // Add spacing between year and statement
            fontSize: '14px', // Slightly smaller font size for the statement
        },
    };

    useEffect(() => {
        // Fetch accounting statements from the API
        axios.get(`${API_BASE_URL}/accounts`)
            .then((response) => {
                const accounts = response.data.accounts.map((account) => ({
                    year: account.year,
                    pdfUrl: `${FILE_BASE_URL}/accounts/${account.pdf}`, // Construct the full PDF URL
                }));
                setAccountingStatements(accounts); // Update state with API data
            })
            .catch((error) => {
                console.error("Error fetching accounting statements:", error);
            });
    }, []);

    const handleCardClick = (pdfUrl) => {
        setSelectedPdf(pdfUrl); // Update the selected PDF

        // Scroll to the iframe on mobile screens
        if (window.innerWidth <= 768 && iframeRef.current) {
            window.scrollTo({
                top: iframeRef.current.offsetTop, // Scroll to the iframe
                behavior: 'smooth', // Smooth scrolling
            });
        }
    };

    const isMobile = window.innerWidth <= 768; // Check if the screen is mobile

    return (
        <div>
            <div
                id="Accountingsection"
                className="tabcontent"
                style={{
                    ...styles.tabContent,
                    ...(isMobile ? styles.responsivePadding : {}), display:'none'// Apply responsive padding for mobile
                }}
            >
                {/* Cards for each year's accounting statement */}
                <div style={styles.cardContainer}>
                    {accountingStatements.map((statement, index) => (
        <div
            key={index}
            style={{
                ...styles.card,
                ...(isMobile ? styles.mobileCard : {}), // Apply mobile-specific styles
                ...(selectedPdf === statement.pdfUrl ? styles.activeCard : {}), // Apply active style if selected
            }}
            onClick={() => handleCardClick(statement.pdfUrl)}
        >
            <span style={styles.yearText}>{statement.year}</span>
            <span style={styles.statementText}>Accounting Statement</span>
        </div>
    ))}
                </div>

                {/* Display the selected PDF */}
                {selectedPdf && (
                    <iframe
                        ref={iframeRef} // Attach the ref to the iframe
                        src={selectedPdf}
                        style={styles.iframe}
                        title="Accounting Section PDF"
                    />
                )}
            </div>
        </div>
    );
}

export default AccountingSection;